<template>
  <div>
    <div class="split" v-for="event in data" v-bind:key="event.event_id">
      <div class="event">
        <span :style="{ borderBottom: '5px ' + event.color + ' solid' }">
          ... {{ event.title }}
        </span>
      </div>
      <div class="prob">
        <div class="estimate">
          {{ event.estimate | percentage(1) }}
        </div>
        <div class="bar-container">
          <div
            class="bar"
            :style="{
              width: (event.estimate * 100) + '%'
            }"
          ></div>
        </div>
      </div>
      <div class="timeline">
        <SparkLine :points="event.predictions" />
      </div>
    </div>
  </div>
</template>

<script>
import SparkLine from "./SparkLine";

export default {
  name: "eventTable",
  props: ["data"],
  components: {
    SparkLine,
  },
};
</script>

<style scoped>
.event {
    margin: 1em 0;
}

.estimate {
    min-width: 9ch;
}


.prob {
  display: flex;
  margin-bottom: 2em;
  padding-right: 2em;
}

.prob .bar-container {
  flex-grow: 1;
}

.prob .estimate {
    font-weight: 800;
    font-style: italic;
    margin-right: 1em;
}

.prob .bar {
  height: 100%;
  background-color: var(--blue-dark);
}

.timeline {
    display: none;
}

@media screen and (min-width: 800px) {
  .timeline {
    display: block;
  }

  .split > div + div {
    margin-left: 1em;
  }

  .event {
    margin: auto;
    flex-basis: 190%;
    line-height: 1.5em;
  }

  .prob {
    margin: auto;
  }

  .prob .estimate {
    margin: 0;
  }

  .prob .bar {
    height: 1em;
  }
}
</style>
